  <template>
  <control-base
    :config="conf"
    :dataType="dataType"
    :parentName="$options.name"
    filterPosition="relative"
    @loaded="$emit('loaded', $event)"
    ref="base"
  >
    <template v-slot:filters>
      <div class="flex-full">
        <p>Show Robots:</p>
        <input type="checkbox" v-model="conf.showRobots" />
      </div>

      <div class="flex-full">
        <p>Talking Colour:</p>
        <span style="width: 50px; height: 10px"></span>
        <colour-picker :color="conf.talkingColor" v-model="conf.talkingColor" />
      </div>

      <div class="flex-full">
        <p>Wrapping Colour:</p>
        <span style="width: 50px; height: 10px"></span>
        <colour-picker
          :color="conf.wrappingColor"
          v-model="conf.wrappingColor"
        />
      </div>

      <div class="flex-full">
        <p>Waiting Colour:</p>
        <span style="width: 50px; height: 10px"></span>
        <colour-picker :color="conf.waitingColor" v-model="conf.waitingColor" />
      </div>
    </template>
    <template v-slot:control>
      <div
        class="component centre"
        :style="{ height: !layoutLocked ? 'calc(100% - 40px)' : '' }"
      >
        <div
          :style="{ backgroundColor: conf.talkingColor }"
          class="stat space-between white"
        >
          <span>Talking</span
          ><span style="font-size: 14pt; font-weight: 700">
            {{ totalTalking }}
          </span>
        </div>
        <div
          :style="{ backgroundColor: conf.wrappingColor }"
          class="stat space-between white"
        >
          <span>Wrapping</span
          ><span style="font-size: 14pt; font-weight: 700">
            {{ totalWrapping }}
          </span>
        </div>
        <div
          :style="{ backgroundColor: conf.waitingColor }"
          class="stat space-between white"
        >
          <span>Waiting</span
          ><span style="font-size: 14pt; font-weight: 700">
            {{ totalWaiting }}
          </span>
        </div>
        <div class="total stat space-between white">
          <span>Total</span
          ><span style="font-size: 14pt; font-weight: 700">
            {{ totalAgents }}
          </span>
        </div>
      </div>
    </template>
  </control-base>
</template>

<script>
export default {
  name: "AvailableAgents",

  props: {
    config: Object,
  },

  data() {
    return {
      dataType: "agent",
    };
  },

  mounted() {
    this.registerDependencies();
  },

  computed: {
    filteredAgents() {
      return this.$store.getters.agentData.filter(
        (x) =>
          (this.conf.showRobots ? true : !x.agentName.startsWith("Robot")) &&
          (this.conf.showGDMSMonitor ? true : !x.agentName.startsWith("gdmsmonitor")) &&
          !x.agentName.startsWith("Spoof") &&
          this.conf.campaignNames.includes(x.campaign)
      );
    },

    totalTalking() {
      return this.filteredAgents.filter((x) => x.agentStateNum == 6).length;
    },

    totalWrapping() {
      return this.filteredAgents.filter((x) => x.agentStateNum == 7).length;
    },

    totalWaiting() {
      return this.filteredAgents.filter((x) => x.agentStateNum == 3).length;
    },

    totalAgents() {
      return this.totalTalking + this.totalWrapping + this.totalWaiting;
    },

    conf() {
      return this.config;
    },

    layoutLocked() {
      return this.$store.getters.locked;
    },
  },

  methods: {
    registerDependencies() {
      this.$store.getters.agentArgs.addProperty("AgentStateNum");
      this.$store.getters.agentArgs.addProperty("AgentName");
      this.$store.getters.agentArgs.addProperty("Campaign");
      this.$store.getters.agentArgs.addAgentState(6);
      this.$store.getters.agentArgs.addAgentState(3);
      this.$store.getters.agentArgs.addAgentState(7);
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.filters {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 0;
  margin-right: -40px;
  position: relative;
}

.component {
  height: 100%;
  width: 100%;
}

.centre {
  display: flex;
  align-items: center;
  justify-content: center;
}

.space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.white {
  color: white;
}

.stat {
  width: 25%;
  height: 100%;
  margin: 10px;
  padding: 5px 10px;
  max-height: 50px;
  border-radius: 6px;
  box-sizing: border-box;
}

.total {
  background-color: #666666;
}
</style>